import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import DistributorMetricsBar from "../../components/distributor/DistributorMetricsBar";
import OrdersTabs from "../orders/OrdersTabs";
import { DISTRIBUTOR_METRICS_DEFAULT_FILTER } from "../../helpers/metricsPeriod";
import "../orders/order.css";
import "./distributor.css";

export default function VaDistributorHome() {
  const { intialSearch, setIntialSearch } = useOutletContext() ?? {};
  const [statsFilter, setStatsFilter] = useState(
    DISTRIBUTOR_METRICS_DEFAULT_FILTER
  );

  return (
    <div className="distributor-dashboard orders-page">
      <DistributorMetricsBar
        filter={statsFilter}
        onFilterChange={setStatsFilter}
      />
      <OrdersTabs
        variant="distributor"
        showStatusCards={false}
        intialSearch={intialSearch ?? ""}
        setIntialSearch={setIntialSearch}
      />
    </div>
  );
}
